import React, { useState } from "react";
import validator from "email-validator";
import {
  BorderContainer,
  Container,
  Close,
  Button,
  Subtitle,
  MainTitle,
  DivWithAccess,
  Access,
  PopupMessage,
  ErrorMess,
  InputC,
} from "../mainStyles";
import { socket } from "../../../REST/api";
import { useSelector } from "react-redux";

import styled from "styled-components";


const PopupCNews = styled(PopupMessage)`
  right: 5rem;
  bottom: 2rem;
`;
const SendPdfComponent = ({ togglePopup }) => {
  const { accessToken: token } = useSelector((state) =>
    state.updateAuthReducer.get("authData")
  );
  const [spinner, setspinner] = useState(false);

  const [sent, setSent] = useState(false);
  const [errorEmail, seterrorEmail] = useState(false);
  const [errorCheckbox, seterrorCheckbox] = useState(false);

  const [email, setemail] = useState("");
  const [checked, setchecked] = useState(true);
  const _sendPdf = (e) => {
    e.preventDefault();
    setspinner(true);

    setSent(false);
    seterrorEmail(false);
    seterrorCheckbox(false);

    if (email !== "" && validator.validate(email) && checked) {
      socket.emit(
        "sendPdf",
        {
          canvasId: localStorage.getItem("id"),
          email,
          token,
        },
        (data) => {
          console.log(data, "sendPdf");

          setTimeout(() => {
            setspinner(false);
            if (data.status === 200) {
              setSent(true);
              seterrorEmail(false);
            } else {
              setSent(false);
              seterrorEmail(true);
            }
          }, 1000);
        }
      );
    } else {
      setspinner(false);
      if (email === "" || !validator.validate(email)) {
        seterrorCheckbox(false);
        seterrorEmail(true);
      } else if (!checked) {
        seterrorCheckbox(true);
        seterrorEmail(false);
      }
    }
  };

  const _handleInput = (e) => {
        seterrorEmail(false);
        setemail(e.target.value);
  };

  return (
    <BorderContainer onClick={togglePopup} id="sendPdf">
      <Container style={{ height: "33rem" }} id="containerSendPdf">
        <Close id={"sendPdf"}>&times;</Close>
        <MainTitle>{"Save Lean Canvas"}</MainTitle>
        <Subtitle style={{ marginBottom: "2rem" }}>
          {
            "Type your email – we will send the Lean Canvas straight to your inbox."
          }
        </Subtitle>
        <DivWithAccess>
          <div
            style={{ display: "flex", flexDirection: "column", width: "55%" }}
          >
            <Access>{"Send by email"}</Access>
            <InputC
              placeholder="email@example.com"
              type="text"
              onChange={_handleInput}
              value={email}
              name="email"
            />
            {email === "" && errorEmail ? (
              <ErrorMess>Email is empty</ErrorMess>
            ) : errorEmail ? (
              <ErrorMess>Please check email</ErrorMess>
            ) : (
              <ErrorMess></ErrorMess>
            )}
          </div>

          <Button onClick={_sendPdf}>
            {spinner ? <div className="spinner" /> : `Send`}
          </Button>
          {sent && <PopupCNews>{"Sent ✅"}</PopupCNews>}
          {errorCheckbox && (
            <PopupCNews>{"Agree to receive the newsletter"}</PopupCNews>
          )}
        </DivWithAccess>

        <label className="container">
          Receive Fulcrum non-spammy newsletter, jam-packed with valuable tips
          and whatnot.
          <input
            type="checkbox"
            defaultChecked={checked}
            onChange={() => setchecked(!checked)}
          />
          <span className="checkmark"></span>
        </label>
      </Container>
    </BorderContainer>
  );
};

export default SendPdfComponent;
